import { c as _c } from "react/compiler-runtime";
import { AuthRole } from '@newfront-insurance/auth-api';
import type { AuthProviderContext, AuthProviderProps } from '@newfront-insurance/next-auth';
import type { Provider } from '@newfront-insurance/react-provision';
import { usePermission } from './use-permission';
export function useIsGrowthCaller(authProvider) {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      scopes: [AuthRole.GROWTH_CALLER]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return usePermission(t0, authProvider);
}